import { FeatureCheckmarkTransparent } from '../../assets/FeatureCheckmarkTransparent'

const FEATURE_SECTIONS = [
  {
    title: 'General',

    items: [
      {
        label: 'Users',
        starter: '1',
        pro: '1',
        ultimate: '4 Users / Add More',
      },

      {
        label: 'Properties Per Month',
        starter: '20',
        pro: '250',
        ultimate: 'Unlimited',
        info: true,
      },
    ],
  },

  {
    title: 'Deal Pipeline',

    items: [
      {
        label: 'Deal Tracking',
        starter: true,
        pro: true,
        ultimate: true,
      },

      {
        label: 'Property Dashboard',
        starter: true,
        pro: true,
        ultimate: true,
      },

      {
        label: 'Property Data & History',
        starter: true,
        pro: true,
        ultimate: true,
      },

      {
        label: 'Custom Tags',
        starter: true,
        pro: true,
        ultimate: true,
      },

      {
        label: 'Notes',
        starter: true,
        pro: true,
        ultimate: true,
      },
    ],
  },

  {
    title: 'Deal Analysis',

    items: [
      {
        label: 'Flip & BRRRR Projection',
        starter: true,
        pro: true,
        ultimate: true,
        info: true,
      },

      {
        label: 'ARV Analysis',
        starter: true,
        pro: true,
        ultimate: true,
        info: true,
      },

      {
        label: 'Rent Comps',
        starter: true,
        pro: true,
        ultimate: true,
        badge: 'COMING SOON',
      },

      {
        label: 'Comp Scoring',
        starter: true,
        pro: true,
        ultimate: true,
      },

      {
        label: 'Deal Scoring',
        starter: true,
        pro: true,
        ultimate: true,
      },

      {
        label: 'Custom Templates',
        starter: true,
        pro: true,
        ultimate: true,
      },
    ],
  },

  {
    title: 'Deal Presentations',

    items: [
      {
        label: 'PDF Reports',
        starter: true,
        pro: true,
        ultimate: true,
        badge: 'COMING SOON',
      },
    ],
  },
]

const renderCell = (value) => {
  if (value === true) {
    return (
      <div className="flex items-center justify-center">
        <div className="w-[28px] h-[28px] rounded-full bg-[#DDF4D0] flex items-center justify-center">
          {/* <img
            src={FeatureCheckmarkTransparent}
            alt="check"
            className="w-[14px] h-[14px]"
          /> */}
          <FeatureCheckmarkTransparent/>
        </div>
      </div>
    )
  }

  return (
    <span className="text-[18px] font-medium text-brand-dark">
      {value}
    </span>
  )
}

const PlanFeatures = () => {
  return (
    <section className="w-full mt-[32px]">
      {FEATURE_SECTIONS.map((section) => (
        <div
          key={section.title}
          className="mb-[44px]"
        >
          {/* Section Header */}
          <div className="pb-4 border-b border-[#B7C7AD]">
            <h2 className="text-[20px] text-left font-bold text-brand-dark">
              {section.title}
            </h2>
          </div>

          {/* Rows */}
          <div>
            {section.items.map((item) => (
              <div
                key={item.label}
                className="
                  grid
                  grid-cols-[2fr_1fr_1fr_1fr]
                  items-center
                  min-h-[58px]
                  border-b
                  border-[#D7E1D1]
                "
              >
                {/* Feature Name */}
                <div className="flex items-center gap-3">
                  <span className="text-[18px] font-medium text-brand-dark">
                    {item.label}
                  </span>

                  {item.info && (
                    <div className="
                      w-[20px]
                      h-[20px]
                      rounded-full
                      border
                      border-[#A8B89F]
                      flex
                      items-center
                      justify-center
                    ">
                      <span className="text-[12px] text-[#A8B89F] font-bold">
                        ?
                      </span>
                    </div>
                  )}

                  {item.badge && (
                    <div className="
                      h-[28px]
                      px-3
                      rounded-[6px]
                      bg-brand-green
                      flex
                      items-center
                      justify-center
                    ">
                      <span className="text-white text-[14px] font-bold tracking-wide">
                        {item.badge}
                      </span>
                    </div>
                  )}
                </div>

                {/* Starter */}
                <div className="flex justify-center">
                  {renderCell(item.starter)}
                </div>

                {/* Pro */}
                <div className="flex justify-center">
                  {renderCell(item.pro)}
                </div>

                {/* Ultimate */}
                <div className="flex justify-center">
                  {renderCell(item.ultimate)}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  )
}

export default PlanFeatures